import { render } from "./chooseJump.vue?vue&type=template&id=adca35ce&scoped=true"
import script from "./chooseJump.vue?vue&type=script&lang=js"
export * from "./chooseJump.vue?vue&type=script&lang=js"

import "./chooseJump.vue?vue&type=style&index=0&id=adca35ce&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adca35ce"]])

export default __exports__